import React from "react";
import { Grid } from "@material-ui/core";
import { useCurrentMarginsDataFilter } from "../../../data/clearing/marginsData/hooks/useMarginsDataFilter";
import { DateInput } from "../../components/common/DateInput";
import { isValidDate } from "../../../core/util/functions";
import { LocalizationContext } from "../../../core/localization/Localization";

export const MarginsDateInput: React.FunctionComponent = () => {
	const [filter, ,setReportDate] = useCurrentMarginsDataFilter();
	const { getString } = React.useContext(LocalizationContext);

	return (
		<Grid container alignItems="center" spacing={2}>
			<Grid item>
				<DateInput
					clearable={false}
					label={getString("marginsDataReportDate")}
					value={filter?.reportDate || null}
					onChange={date => {
						if (isValidDate(date)) {
							setReportDate(date.toISOString());
						}
					}}
					disableFuture
				/>
			</Grid>
		</Grid>
	);
};
